import { Container, Grid, Typography } from "@material-ui/core";
import TVLogo from "../../assets/tv.png";

import "./index.less";

export default function GameDesc() {
  return (
    <div className="game-desc">
      <Container maxWidth="lg">
        <Grid
          container
          spacing={4}
          alignContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} md={5} className="airdrop-desc">
            <Typography component="div" variant="h4" className="title">
              <span style={{ color: "#ffc938" }}>Treasure</span> hunt game
            </Typography>
            {/* <Typography component="div" variant="h5" className="sub-title">
              <span style={{ color: "#ffc938" }}># Treasure Hunt</span>
            </Typography> */}
            <Typography
              component="div"
              variant="h6"
              paragraph
              className="content"
            >
              After launch, there will be a treasure hunt game open to all NFT
              collectors who holds specific NFTs for free. The game is a
              mine-sweeper like game where player needs to click the blank boxes
              to find the treasure (1 KungFu NFT).
            </Typography>
            <Typography
              component="div"
              variant="h6"
              paragraph
              className="content rules"
            >
              There is a time limit on clicking:
              <p>
                1. If you own{" "}
                <span style={{ color: "#ffc938" }}>1 KungFu Hero</span>, you can
                sweep every <span style={{ color: "#ffc938" }}>4 minutes</span>;
              </p>
              <p>
                2. If you own{" "}
                <span style={{ color: "#ffc938" }}>2-5 KungFu Hero</span>, you
                can sweep every{" "}
                <span style={{ color: "#ffc938" }}>2 minutes</span>;
              </p>
              <p>
                3. If you own over{" "}
                <span style={{ color: "#ffc938" }}>5 KungFu Hero</span>, you can
                sweep <span style={{ color: "#ffc938" }}>every minute</span>.
              </p>
              <p>
                4. If you are holder of other NFTs, you can sweep every{" "}
                <span style={{ color: "#ffc938" }}>5 minutes</span>.
              </p>
            </Typography>
          </Grid>
          <Grid item xs={12} md={5} className="tv-img">
            <img src={TVLogo} width="100%" alt="" />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
